<template>
  <div class="auth-as">
    <button @click="doLogin" v-if="!user">
      <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg">
      <span>Login with google</span>
    </button>
    <button class="clickable logout" @click="doLogout" v-if="user"><img class="photo" :src="user.photoURL">
      <span>Logout {{ user.displayName }}</span>
    </button>
  </div>
</template>

<script>
  import firebase from 'firebase'
  import { mapState } from 'vuex'

  export default {
    name: 'firebaseAuth',
    computed: {
      ...mapState('firebaseAuth', ['user'])
    },
    methods: {
      doLogin () {
        const provider = new firebase.auth.GoogleAuthProvider()
        firebase.auth().signInWithRedirect(provider)
      },
      doLogout () {
        firebase.auth().signOut()
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// FirebaseAuth.vue?04eda192